import { useSelector } from 'react-redux';
import { PartnerLayoutWithSidebar } from '../../../common/components';
import { getSelectedOrg } from '../../../common/store';
import CampaignApprovalList from '../../common/campaign-approval/CampaignApprovalList';

const PartnerCampaignApprovalList = () => {
    const selectedOrg = useSelector(getSelectedOrg);
    const orgId = selectedOrg?.id as string;

    return (
        <PartnerLayoutWithSidebar>
            <CampaignApprovalList orgId={orgId} />
        </PartnerLayoutWithSidebar>
    );
};

export default PartnerCampaignApprovalList;
